import { supabase } from "./supabase"
import type { Tag } from "../types"
import ENV from "@/env"

export async function getNativeArPrice(): Promise<number> {
  const { data, error } = await supabase.functions.invoke('usd-price', {
    body: {
      processId: ENV.VITE_WRAPPED_AR_PROCESS,
    }
  })

  if (error) {
    throw new Error(`Supabase function error: ${error.message}`)
  }

  if (!data) {
    throw new Error("No response from usd-price")
  }


  const value = Number.parseFloat(data.price)

  if (Number.isNaN(value)) throw new Error("Response malformed")

  return value
}
